import React, { memo } from 'react';
import {
  Stack,
  Typography,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  LinearProgress,
  Icon
} from 'investira.react.components';

const SessaoNavProgress = memo(props => {
  const { sessoes = {}, activeCategoryId, onClick } = props;

  return (
    <Stack gap={2}>
      <Stack>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
          Sessões
        </Typography>
        <Stack
          sx={{
            width: 'stretch'
          }}>
          <List component="nav">
            {Object.values(sessoes).map((xSessao, xIndex) => {
              return (
                <ListItemButton
                  selected={xSessao.id === activeCategoryId}
                  onClick={e => onClick(e, xSessao, xIndex)}
                  sx={{
                    borderRadius: 2 // Valor 2 do theme.spacing (ex: 16px). Ajuste se quiser valores diferentes.
                  }}>
                  <ListItemIcon>
                    <Icon
                      iconName={xSessao.completed ? 'option_select' : 'option'}
                      color={xSessao.completed ? 'primary' : 'textSecondary'}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={<Typography variant="caption">{xSessao.label}</Typography>}
                    secondary={<LinearProgress variant="determinate" value={xSessao.progression} />}
                  />
                </ListItemButton>
              );
            })}
          </List>
        </Stack>
      </Stack>
    </Stack>
  );
});

export default SessaoNavProgress;
